import { createSystem, defaultConfig } from '@chakra-ui/react';

import { raspberryBaseTheme } from './base';

const raspberrySsrTheme = createSystem(defaultConfig, raspberryBaseTheme, {
    globalCss: {
        '*': {
            focusRing: 'none',
            focusVisibleRing: 'outside',
            focusRingColor: '{colors.focusRing}',
        },

        ':where(a[href]:not([class]))': {
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
            textDecorationColor: 'currentColor/20',
        },
    },
});

export default raspberrySsrTheme;
